import { Component } from 'react';
import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';

export default class TaskErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        Sentry.captureException(error, { extra: info });
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        Something went wrong loading this section.
                    </Typography>
                    <Button size="small" onClick={() => this.setState({ hasError: false })}>
                        Try Again
                    </Button>
                </Box>
            );
        }
        return this.props.children;
    }
}

TaskErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};
